import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Alert, Input, Label} from 'reactstrap';
import {FaDonate} from "react-icons/fa";
import Breadcrumb from '../../Layout/Breadcrumb';
import { Spinner } from 'react-bootstrap';

class AddCreditForUserComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            btnSubmit: false,
            error: false,
            messageError: '',
            errorForm: false,
            messageForm: '',
            loadPage: true,
            user: {},
            amount: 0,
            text_amount: '',
            action: 'add',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getUserDetail(this.props.userId);
    }

    getUserDetail = (userId) => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get(process.env.REACT_APP_API_URL + '/api/admin/user/detailUser/' + userId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0)  {
                    this.setState({
                        user: ref.data.content,
                        loadPage: false,
                        isLoading: false
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000  ) {
                        this.redirect(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                    loadPage: false,
                    isLoading: false
                })
            })
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value
        })
    }

    changeInputAmount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        for (let index = 1; index < 10; index++) {
            value = value.replace('.', '');
            value = value.replace(',', '');
        }
        this.setState({
            [name]: value,
            text_amount: this.addCommas(value)
        })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    submit = () => {
        if (this.validate()) {
            this.setState({
                loadPage: true
            })
            let form = {
                userId: this.props.userId,
                amount: this.state.amount,
                action: this.state.action,
            }
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.post( process.env.REACT_APP_API_URL + '/api/admin/payment/rechargeCreditForUser', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.redirectBack( ref.data.message );
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                errorForm: true,
                                messageForm: ref.data.message,
                                loadPage: false,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        errorForm: true,
                        messageForm: 'Tạo nạp tiền cho khách hàng thất bại',
                        loadPage: false,
                        name: '',
                    })
                })
        }
    }

    validate = () => {
        if (Number.isNaN(this.state.amount)) {
            this.setState({
                errorForm: true,
                messageForm: 'Số tiền phải là ký tự số'
            })
            return false;
        }
        return true;
    }

    redirect = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.shouldRedirect();
    }

    redirectBack = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectBack();
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Yêu cầu nạp tiền"} page={"Nạp tiền"}
                                        icon={<FaDonate className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        { this.state.messageError }
                                    </Alert>
                                ) : (
                                    <div className="col-md-6 marginAuto">
                                        <div className="card card-info">
                                            <div className="card-header">
                                                <h3 className="card-title text-center">Thông tin đại lý</h3>
                                            </div>
                                            <div className="card-body">
                                                {
                                                    this.state.errorForm ? (
                                                        <Alert color="danger">
                                                            { this.state.messageForm }
                                                        </Alert>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="form-group">
                                                    <Label>Khách hàng</Label>
                                                    <Input className="form-control" defaultValue={ this.state.user.name }
                                                           type="text" disabled={true}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <Label>Số dư tài khoản</Label>
                                                    <input defaultValue={ this.state.user.sdtk } className="form-control"
                                                           type="text" disabled={true}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <Label>Hành động</Label>
                                                    <select name="action" id="action"
                                                            onChange={ this.changeInput }
                                                            className="form-control"
                                                            value={ this.state.action }
                                                    >
                                                        <option value="add">Cộng tiền tài khoản</option>
                                                        <option value="minus">Trừ tiền tài khoản</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <Label>Số tiền nạp</Label>
                                                    <input className="form-control" type="text" name="amount"
                                                           value={ this.state.text_amount } onChange={ this.changeInputAmount }
                                                           placeholder="Số tiền"
                                                    />
                                                </div>
                                                <div className="form-group text-center">
                                                    <button className="btn btn-primary" onClick={ () => this.submit() }>Xác nhận</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({type : 'logOut'}))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddCreditForUserComponent);